import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerBnkDetailsAction,
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateBnkDetailsAction,
  adminCustomerUpdateContactPersonAction,
  relationAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import DatePicker from "react-datepicker";
import ItemsInputField from "../forms/items-input-field";
import TickIcon from "../../assets/icons/tick-icon";
import { useNavigate } from "react-router-dom";
import { handelLabel } from "./handel-label";
import { handelEnabled } from "./handel-enabled";
import BankDetailsTab from "./bank-details-tab";
import Bank2Icon from "../../assets/icons/admin-customer-icons/bank2-icon";
import * as Yup from "yup";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Banking({
  banking,
  page,
  disabled,
  setCurrentTab,
  bankingId,
  customization,
  customerId,
  // loading,
  // setLoading,
}) {
  const [loading, setLoading] = useState(false);
  const [customData, setcustomData] = useState([]);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    bank: localStorageData?.banking ?? banking,
  };

  const addBank = {
    cmr_id: customerId,
    // cmr_bank_id: bankingId ?? initialValues.bank[0].cmr_bank_id,
    cmr_bank_name: "",
    cmr_account_no: "",
    cmr_ifsc_code: "",
    cmr_bank_branch: "",
    cmr_default_bank_details: false,
  };

  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  //   useEffect(() => {}, []);
  const onSuccess = (data) => {
    setLoading(false);
    successToast(data.message);
    setCurrentTab("Payment");
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data.message);
  };

  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          banking: values.bank,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };
  const handleDefaultBank = (values, setFieldValue, selectedIndex) => {
    const updatedBank = values.bank.map((item, index) => ({
      ...item,
      cmr_default_bank_details: index === selectedIndex,
    }));

    setFieldValue("bank", updatedBank);
  };

  const handleAddBank = (values, setFieldValue) => {
    const updatedBank = [...values.bank, { ...addBank }];
    setFieldValue("bank", updatedBank);
  };

  const handleDeleteBank = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one bank");
    else if (values.bank[index].cmr_default_bank_details === true) {
      return errorToast("Cannot delete the default bank");
    } else {
      const updatedBank = values.bank.filter((_, i) => i !== index);
      setFieldValue("bank", updatedBank);
    }
  };

  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;
    setLoading(true);
    let sendData = [...values.bank];
    if (page !== "edit") {
      let firstItem = values.bank[0];
      let updatedFirstItem = {
        ...firstItem,
        cmr_id: customerId,
        cmr_bank_id: bankingId,
      };
      sendData[0] = updatedFirstItem;
    }
    // console.log("11", sendData);
    dispatch(
      adminCustomerUpdateBnkDetailsAction(
        { customerBankData: values.bank },
        onSuccess,
        onError
      )
    );
  };
  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "bank");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);
  const IFSC_Type = /^[A-Z]{4}0[A-Z0-9]{6}$/; // ✅ Regex literal
  const validationSchema = Yup.object().shape({
    bank: Yup.array().of(
      Yup.object().shape({
        cmr_ifsc_code: Yup.string()
          .nullable()
          .transform((value) => (value ? value.trim().toUpperCase() : value))
          .test(
            "ifsc-format",
            "Please enter a valid IFSC code",
            function (value) {
              if (!value) return true; // nullable
              return value.length === 11 && IFSC_Type.test(value);
            }
          ),
        cmr_account_no: Yup.string()
          .nullable()
          .min(9, "Account number must be at least 9 characters")
          .max(18, "Account number must not exceed 18 characters"),
      })
    ),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          <UpdateLocalStorage values={values} />
          {/* <UpdateCmrId customerId={customerId} /> */}
          {/* <UpdateBankId bankingId={bankingId} /> */}
          <LoadingOverlay isLoading={loading} />
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Bank2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Bank Account Information
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Add primary bank account details for financial transactions
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddBank(values, setFieldValue)}
                  text={<span>Add Another Account</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            </div>
            {values?.bank?.map((item, index) => (
              <div
                // key={index}
                className="px-[34px] pt-[34px] pb-[10px] flex-col rounded-2xl bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
              >
                <div className="flex mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    <PaymentAddressIcon />
                    <div className="flex flex-col self-center">
                      <label className="h-full text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        {item.cmr_default_bank_details ? "Primary" : null} Bank
                        Account
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    {item.cmr_default_bank_details ? (
                      <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                        <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                          Default
                        </label>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          if (page !== "view") {
                            handleDefaultBank(values, setFieldValue, index);
                          }
                        }}
                        className="px-5 py-[5px] rounded-full bg-[var(--customer-set-default-bg)] flex items-center cursor-pointer"
                      >
                        <label className="text-[var(--customer-set-default-fg)] font-[var(--customer-default-fw)]">
                          Set as Default
                        </label>
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        if (page !== "view") {
                          handleDeleteBank(
                            index,
                            values,
                            setFieldValue,
                            values.bank.length
                          );
                        }
                      }}
                      className={`${
                        values.bank.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>

                {/* Grid Layout for Form Fields */}
                <div
                  className="grid  gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_bank_name",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`bank[${index}].cmr_bank_name`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_bank_name",
                          customData
                        )}`}
                        allowSpecial={true}
                        label={handelLabel("cmr_bank_name", customData)}
                        isDisabled={handelEnabled(
                          "cmr_bank_name",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_account_no",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        maxLength={18}
                        type="number"
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`bank[${index}].cmr_account_no`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_account_no",
                          customData
                        )}`}
                        label={handelLabel("cmr_account_no", customData)}
                        isDisabled={handelEnabled(
                          "cmr_account_no",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_bank_branch",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`bank[${index}].cmr_bank_branch`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_bank_branch",
                          customData
                        )}`}
                        label={handelLabel("cmr_bank_branch", customData)}
                        isDisabled={handelEnabled(
                          "cmr_bank_branch",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ifsc_code",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        maxLength={11}
                        allowSpecial={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`bank[${index}].cmr_ifsc_code`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ifsc_code",
                          customData
                        )}`}
                        label={handelLabel("cmr_ifsc_code", customData)}
                        isDisabled={handelEnabled(
                          "cmr_ifsc_code",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
            <div className="flex flex-col gap-2 p-[26px] rounded-xl bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]">
              <div>
                <label className="leading-normal text-[var(--customer-sub-title-fg)] text-[length:var(--customer-sub-title-2-fs)] font-[var(--customer-sub-title-2-fw)] w-full">
                  💡 Important Tips
                </label>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <TickIcon className="w-5 h-5 flex-shrink-0" />
                <label className="leading-normal text-[var(--customer-info-fg)] text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)] w-full">
                  Double-check all bank details - they will be used for payments
                </label>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <TickIcon className="w-full" />
                <label className="leading-normal text-[var(--customer-info-fg)] text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)] w-full">
                  IFSC code helps identify your bank branch across India
                </label>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <TickIcon className="w-full" />
                <label className="leading-normal text-[var(--customer-info-fg)] text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)] w-full">
                  You can add multiple accounts for different purposes
                </label>
              </div>
            </div>

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${customerId}`, {
                      state: { tab: "Banking" },
                    })
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Banking;

function UpdateCmrId({ customerId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    console.log(",,,", customerId);
    if (values.bank?.[0] && !Object.hasOwn(values.bank[0], "cmr_id")) {
      setFieldValue("bank[0].cmr_id", customerId);
    }
  }, [customerId, setFieldValue]);

  return null;
}

function UpdateBankId({ bankingId }) {
  const { values, setFieldValue } = useFormikContext();
  // console.log("...", bankingId);
  useEffect(() => {
    if (values.bank?.[0] && !Object.hasOwn(values.bank[0], "cmr_bank_id")) {
      setFieldValue("bank[0].cmr_bank_id", bankingId);
    }
  }, [bankingId]);

  return null;
}
